import React, { useEffect } from 'react';

import Alert from 'react-s-alert';
import Helmet from 'react-helmet';

import { default as config } from '../config';

import Header from './page/Header';

import { getUser, verifySession } from '../actions/account';
import { useDispatch, useSelector } from 'react-redux';
import auth from '../utils/auth';
import { Outlet, useNavigate } from 'react-router-dom';
import { sessionDestroy, sessionSuccess } from '../slices/sessionSlice';

const AppLayout = () => {
    const session = useSelector((state) => state.session);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        const verify = async () => {
            const userId = auth.getUserId();
            try {
                if (!session?._id) {
                    let {
                        data: { valid }
                    } = await verifySession(userId);

                    if (!valid) {
                        throw new Error();
                    }

                    let { data } = await getUser(userId);
                    dispatch(sessionSuccess(data));
                }
            } catch (error) {
                console.error(error);
                auth.logout();
                dispatch(sessionDestroy());
                navigate('/login');
            }
        };
        if (auth.loggedIn()) {
            verify();
        }
    }, [dispatch, navigate, session._id]);
    return (
        <div className="site">
            <Helmet title="Playaway Admin" />
            <Header />
            <main>
                <Outlet />
            </main>
            <footer className="footer">
                {config.env === 'dev' && <div className="txt-center">React Version {React.version}</div>}
            </footer>
            <Alert stack={{ limit: 3 }} />
        </div>
    );
};

export default AppLayout;
